"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SectionContainer;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
// TODO: need to get the device and size objects from the pattern-library
const Container = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "Container",
  class: "pl-c1qgppxm",
  vars: {
    "c1qgppxm-2": [({
      containerStyle
    }) => containerStyle === 'container' ? '720px' : 'unset'],
    "c1qgppxm-4": [({
      containerStyle
    }) => containerStyle === 'container' ? '940px' : 'unset'],
    "c1qgppxm-6": [({
      containerStyle
    }) => containerStyle === 'container' ? '80vw' : 'unset']
  }
});

/**
 * Render FOS PlanBox Section
 * @module SectionContainer
 *
 * @param {Object} props React props
 * @param {string} props.containerStyle Container style string.
 * @param {object} [props.style] Additional container styles.
 * @param {React.ReactNode} [props.children] Children components
 * @returns {React.ReactElement} PlanBox element
 * @public
 */

function SectionContainer({
  containerStyle = 'container-fluid',
  style,
  children
}) {
  return /*#__PURE__*/_react.default.createElement(Container, {
    containerStyle: containerStyle,
    style: style
  }, children);
}
SectionContainer.propTypes = {
  containerStyle: _propTypes.default.oneOf(['container', 'container-fluid']),
  style: _propTypes.default.object,
  children: _propTypes.default.node
};